import React, { useEffect, useState } from 'react';
import './tasksInt.css';
import TaskCardInt from './TaskCard';
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";
import TaskCardCompletedInt from "./taskCardCompleted";
import {useHistory} from "react-router-dom";
import { tutorDetailsTasksConfig, globalColors } from './tutorDetailsTasksConfig';

function TasksInt(props) {
	const { data, bottomCard, campaignOrg, scrollNav, swipeActions } = props;
	const text = tutorDetailsTasksConfig.text || {};
	const taskPageStyle = {
		'--tasks-warm-text': globalColors.subheading || 'rgba(108, 39, 24, 1)',
		'--tasks-primary-cta-background': globalColors.accent_color || '#E35C22',
		'--tasks-primary-cta-text': globalColors.button_text || '#fff',
		'--tasks-incomplete-card-border': globalColors.accent_color || '#E35C22',
		'--tasks-incomplete-progress-track': globalColors.progress_background || 'rgba(222, 208, 198, 1)',
		'--tasks-incomplete-progress-fill': globalColors.accent_color || '#E35C22',
		'--tasks-accent': globalColors.accent_color || '#E35C22',
		'--tasks-incomplete-card-background': globalColors.card_background || '#FFF1DAB2',
		'--tasks-completed': globalColors.success_color || '#0D913E',
	};
	const history = useHistory();
	return (
		<>
			<div className="page-content page-content-task" {...swipeActions} style={taskPageStyle}>
				<div className="task-page-header">
					<h2>{text.heading || 'How to earn points?'}</h2>
					<p>{text.description || 'You can earn points by doing some simple tasks and teaching your students'}</p>
				</div>
				<div className="task-page-cards">
					<TaskCardInt data={data} scrollNav={scrollNav} campaignOrg={campaignOrg}/>
				</div>
				<TaskCardCompletedInt data={data} scrollNav={scrollNav}
									  campaignOrg={campaignOrg} heading={text.completed_heading}></TaskCardCompletedInt>
				
				{/* <div className="task-bottom-card">
					<h2>Earn more points <span>by completing below tasks</span></h2>
					<p>Each Task Contain 100 points </p>
					<BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg}></BottomCardGroupInt>
				</div> */}
			</div>
		</>
	);
}

export default TasksInt;
